import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faMessage,
  faRotate,
} from "@fortawesome/free-solid-svg-icons";

export default function ChatbotPreview({ config, mobile = false }) {
  const [open, setOpen] = useState(true);
  const [cleared, setCleared] = useState(false);
  const dark = config.theme === "dark";
  const style = { "--bot-color": config.primaryColor || "#556ee6" };
  return (
    <div
      className={`preview-stage ${mobile ? "phone-stage" : ""}`}
      style={style}
    >
      <div className="preview-page">
        <i />
        <i />
        <i />
        <span />
      </div>
      {open && (
        <section className={`chat-preview ${dark ? "chat-dark" : ""}`}>
          <header>
            <div className="bot-avatar">
              {config.avatar ? (
                <img src={config.avatar} alt="" />
              ) : (
                <FontAwesomeIcon icon={faMessage} />
              )}
            </div>
            <div>
              <strong>{config.name || "Website Assistant"}</strong>
              <small>
                <i /> Online
              </small>
            </div>
            <button
              type="button"
              onClick={() => setCleared(true)}
              aria-label="Clear preview conversation"
            >
              <FontAwesomeIcon icon={faRotate} />
            </button>
          </header>
          <div className="preview-messages">
            <div className="bot-message">
              {config.welcomeMessage || "Hi! How can I help you?"}
              <time>Now</time>
            </div>
            {!cleared && (
              <>
                <div className="user-message">
                  What services do you offer?<time>Now</time>
                </div>
                <div className="bot-message">
                  I can answer using this website’s approved knowledge. Ask me
                  about a specific service.<time>Now</time>
                </div>
              </>
            )}
          </div>
          <footer>
            <span>{config.placeholder || "Ask a question…"}</span>
            <button type="button" aria-label="Send message">
              <FontAwesomeIcon icon={faArrowUp} />
            </button>
          </footer>
          {config.showBranding && (
            <small className="preview-branding">
              Powered by <strong>FlowChat</strong>
            </small>
          )}
        </section>
      )}
      <button
        type="button"
        className="preview-launcher"
        onClick={() => {
          setOpen(!open);
          setCleared(false);
        }}
        aria-label={open ? "Close chatbot preview" : "Open chatbot preview"}
      >
        <FontAwesomeIcon icon={faMessage} />
      </button>
    </div>
  );
}
